  'use strict';
 
  /**
  * track virtual page views for all page.
  */ 
  function JWTTimeoutService($state, jwtHelper, storage, labelService, MODULE_INFO) {

    function isSessionTimedout() {
    	var eyUserToken = storage.getItem('eyUserToken');
      	if( typeof(eyUserToken) == 'string' &&
			jwtHelper.isTokenExpired(eyUserToken)){
			return true;
	    } else {
	    	return false;
	    }

  	}

  	function handleTimeout() {
  		var sessionTimeoutMessage = labelService.getGlobalOptionLabel('content', 'session_timeout_message');
  		alert(sessionTimeoutMessage  || 'Your session has timed out!');
		storage.clear();
		$state.go(MODULE_INFO.startRouteName);
  	}

    return {
    	isSessionTimedout : isSessionTimedout,
    	handleTimeout : handleTimeout	
    } 
  }
